import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/login',
		method: 'post',
		data: data
	})
}

AuthService.verifyTwoFactorCode = function (data) {
	return fetch({
		url: '/login/verify-code',
		method: 'post',
		data: data
	})
}

AuthService.resendTwoFactorCode = function (data) {
	return fetch({
		url: '/login/resend-code',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}


export default AuthService;